import { Button } from "@/components/ui/button";
import { ArrowDown } from "lucide-react";

export default function HeroSection() {
  const scrollToSection = (id) => {
    const element = document.querySelector(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="min-h-screen flex items-center pt-20 bg-[#F9F6F0]"
      data-testid="hero-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text Content */}
          <div className="order-2 lg:order-1 animate-fade-in-up">
            <h1 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl lg:text-6xl font-medium text-[#1A1A1A] leading-tight mb-6">
              Creative Facilitation
              <br />
              <span className="text-[#8B5A2B]">using Drama</span>
            </h1>
            <p className="font-['Cormorant_Garamond'] text-2xl sm:text-3xl text-[#4A4542] font-light mb-6">
              Voice, Presence & Confidence at Work
            </p>
            <p className="font-['Manrope'] text-base lg:text-lg text-[#4A4542] mb-10 max-w-xl">
              Using rehearsal-room techniques to help individuals and teams
              communicate with clarity, confidence and authenticity.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={() => scrollToSection("#contact")}
                className="btn-primary px-8 py-6 text-base font-['Manrope'] font-medium tracking-wide rounded-none"
                data-testid="hero-contact-btn"
              >
                Contact Me
              </Button>
              <Button
                onClick={() => scrollToSection("#intro")}
                variant="outline"
                className="btn-outline px-8 py-6 text-base font-['Manrope'] font-medium tracking-wide rounded-none"
                data-testid="hero-learn-more-btn"
              >
                Learn More
              </Button>
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 animate-fade-in animation-delay-200">
            <div className="relative">
              {/* Decorative background */}
              <div className="absolute -top-4 -left-4 w-full h-full bg-[#C5A059]/20 z-0"></div>
              <div className="relative z-10">
                <img
                  src="https://customer-assets.emergentagent.com/job_e01f95fe-37b3-4b42-94dd-2a1ad76dcc2c/artifacts/lmiy34c2_Manisha.png"
                  alt="Manisha - Creative Facilitator"
                  className="w-full h-auto object-cover"
                  data-testid="hero-image"
                />
              </div>
              {/* Bottom accent */}
              <div className="absolute -bottom-4 -right-4 w-3/4 h-3/4 border-2 border-[#8B5A2B]/30 z-0"></div>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="hidden lg:flex justify-center mt-16 animate-fade-in animation-delay-400">
          <button
            onClick={() => scrollToSection("#intro")}
            className="flex flex-col items-center text-[#4A4542] hover:text-[#8B5A2B] transition-colors"
            aria-label="Scroll down"
            data-testid="scroll-indicator"
          >
            <span className="font-['Manrope'] text-xs uppercase tracking-widest mb-2">
              Discover
            </span>
            <ArrowDown size={20} strokeWidth={1.5} className="animate-bounce" />
          </button>
        </div>
      </div>
    </section>
  );
}
